import { IndeterminateCheckbox } from "./IndeterminateCheckbox";
import React from "react";

export const HeaderRenderer = ({ getToggleAllRowsSelectedProps }) => (
  <div>
    <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
  </div>
);
